/**
 * @generated SignedSource<<7fa80f5623427071ef21160983be2655>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomePageQuery$variables = {
  userId: string;
};
export type HomePageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CompanionContent_data">;
};
export type HomePageQuery = {
  response: HomePageQuery$data;
  variables: HomePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "fields": (v1/*: any*/),
  "kind": "ObjectValue",
  "name": "filterBy"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "careType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surname",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v10 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "CompanionContent_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomePageQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          (v2/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 2
          },
          {
            "kind": "Literal",
            "name": "include",
            "value": {
              "cancelled": false,
              "groupSessions": true
            }
          },
          {
            "kind": "Literal",
            "name": "only",
            "value": "UPCOMING"
          },
          {
            "kind": "Literal",
            "name": "sortBy",
            "value": {
              "scheduledDate": "ASC"
            }
          }
        ],
        "concreteType": "SessionsResponseConnection",
        "kind": "LinkedField",
        "name": "sessions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "GroupSession",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "Session",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "number",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "checkoutUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPendingCheckInSurvey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "professional",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClinicalProfile",
                            "kind": "LinkedField",
                            "name": "clinicalProfile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "image",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "professionalTitle",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "employee",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Therapy",
                        "kind": "LinkedField",
                        "name": "therapy",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paymentStatus",
                        "storageKey": null
                      }
                    ],
                    "type": "Session",
                    "abstractKey": null
                  }
                ],
                "type": "SessionResponse",
                "abstractKey": "__isSessionResponse"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v9/*: any*/),
          {
            "kind": "Literal",
            "name": "type",
            "value": "WELLBEING"
          }
        ],
        "concreteType": "ThreadConnection",
        "kind": "LinkedField",
        "name": "threads",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ThreadEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": "threads(first:1,type:\"WELLBEING\")"
      },
      {
        "alias": null,
        "args": [
          (v2/*: any*/),
          (v9/*: any*/)
        ],
        "concreteType": "WellbeingProfileResultConnection",
        "kind": "LinkedField",
        "name": "wellbeingProfileResults",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WellbeingProfileResult",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc3c1471d51035dd57567200806d769d",
    "id": null,
    "metadata": {},
    "name": "HomePageQuery",
    "operationKind": "query",
    "text": "query HomePageQuery(\n  $userId: String!\n) {\n  ...CompanionContent_data_1xxw8p\n}\n\nfragment CompanionContent_data_1xxw8p on Query {\n  ...UpcomingEventsFragment_data_1xxw8p\n  threads(first: 1, type: WELLBEING) {\n    edges {\n      __typename\n    }\n  }\n  wellbeingProfileResults(filterBy: {userId: $userId}, first: 1) {\n    nodes {\n      __typename\n    }\n  }\n}\n\nfragment UpcomingEventsFragment_data_1xxw8p on Query {\n  sessions(filterBy: {userId: $userId}, only: UPCOMING, include: {groupSessions: true, cancelled: false}, sortBy: {scheduledDate: ASC}, first: 2) {\n    nodes {\n      __typename\n      ... on GroupSession {\n        id\n      }\n      ... on Session {\n        id\n      }\n      ...useSessionCard_session\n    }\n  }\n}\n\nfragment useSessionCard_session on SessionResponse {\n  __isSessionResponse: __typename\n  __typename\n  ... on Session {\n    id\n    type\n    number\n    checkoutUrl\n    hasPendingCheckInSurvey\n    status\n    endDate\n    startDate\n    careType\n    professional {\n      name\n      surname\n      clinicalProfile {\n        image\n        professionalTitle\n      }\n      id\n    }\n    employee {\n      name\n      surname\n      id\n    }\n    therapy {\n      careType\n      id\n    }\n    paymentStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c301e5b134691068225cbc71aee3598";

export default node;
